import { useEffect, useState, useCallback, useRef } from "react";
import ButtonIconH from "../../components/ButtonIconH";
import "../../css/ProductImg.css";

export default function LogoImg({ img, onUpload, onDelete }) {
  const [logoImage, setLogoImage] = useState(null);
  const inputRef = useRef(null);

  const handleFileInputChange = useCallback(
    (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result;
        setLogoImage(base64String);
        onUpload(base64String, file.name);
      };
      reader.readAsDataURL(file);
    },
    [onUpload]
  );

  const handleDragEvents = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      const file = e.dataTransfer.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result;
        setLogoImage(base64String);
        onUpload(base64String, file.name);
      };
      reader.readAsDataURL(file);
    },
    [onUpload]
  );

  useEffect(() => {
    setLogoImage(img);
  }, [img]);

  return (
    <div
      className="product-img-container"
      onDragOver={handleDragEvents}
      onDragEnter={handleDragEvents}
      onDragLeave={handleDragEvents}
      onDrop={handleDrop}
    >
      {logoImage && <img className="pic" src={logoImage} alt="logo" />}

      {!logoImage && (
        <>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileInputChange}
          />
          <div
            style={{
              display: "flex",
              height: "100%",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <img
              src="/images/new-blue.svg"
              className="icon"
              alt="Nueva imagen"
              title="Nueva imagen"
              onClick={() => inputRef.current.click()}
            />
            <span style={{ fontSize: "12px", fontStyle: "italic" }}>
              Haga clic o arrastre aquí la imagen
            </span>
          </div>
        </>
      )}

      {logoImage && <ButtonIconH text="Eliminar" small onClick={onDelete} />}
    </div>
  );
}
